export function createKitchenAllPrinter() {
  return {
    id: "kitchen-all",
    generalTab: {
      name: "Kitchen All",
      apikey: "KITCHEN-ALL",
      autoPrint: true,
      autoPrintAfterConfirmation: false,
      printLanguage: "English",
      disable: false,
      email: "",
    },
    settingsTab: {},
    itemsTab: {
      kitchenSlip: true,
      cutbyCategory: false,
      cutbyItem: false,
      checkedItems: [],
      allItems: true,
    },
    hfTab: {},
    cloudPrintTab: { isEnabled: false },
    updated: new Date().toISOString(),
  };
}

export function createMevPrinterSetting() {
  return {
    id: "mev-receipt-printer",
    generalTab: {
      name: "Cloud MEV Receipt Printer",
      apikey: "MEV-RECEIPT-PRINTER",
      autoPrint: true,
      autoPrintAfterConfirmation: false,
      printLanguage: "English",
      disable: false,
      email: "",
    },
    settingsTab: {},
    itemsTab: { posReport: true },
    hfTab: {},
    updated: new Date().toISOString(),
  };
}
